export enum UserMessageAppendStrategy {
  APPEND,
  SKIP_APPEND,
}
